/**
 * © [2025] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './ActionTypes';

const axiosPayLoad = {
  ineligibleCPTListData: [],
  errorMessagesInRedux: [],
  gridData: [],
  ineligiblePrvUpdateRes: [],
  deletedData: [],
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_INELIGIBLE_CPT_DATA:
      return {
        ...state,
        ineligibleCPTListData: action.ineligibleCPTListData,
      };
    case actionTypes.HANDLE_ERROR_MESSAGE_MICPT:
      return { ...state, errorMessagesInRedux: action.payload };
   case actionTypes.SET_GRID_DATA_INELIGIBLE_CPT: {
  const data = Array.isArray(action.payload) ? action.payload : [];

  const newRecords = data.filter((el) => el.newRecord);
  const existingRecords = data.filter((el) => !el.newRecord);

  const normalizedGridData = [...newRecords, ...existingRecords].map((item) => ({
    ...item,
    ineligProviderBeginDtErr: item.ineligProviderBeginDtErr || false,
    endDtErr: item.endDtErr || false,
    procedureCdErr: item.procedureCdErr || false,
    addEditRow: item.addEditRow || false,
    deleteRecord: item.deleteRecord || false,
    isUpdateIneligProviderBeginDt: item.isUpdateIneligProviderBeginDt || false,
    isUpdateEndDt: item.isUpdateEndDt || false,
  }));

  return { ...state, gridData: normalizedGridData };
}

    case actionTypes.INELIGIBLE_CPT_ADD_EDIT_RES:
      return { ...state, ineligiblePrvUpdateRes: action.payload };
    case actionTypes.RESET_INELIGIBLE_CPT_REDUX_STORE:
      return { ...axiosPayLoad };
    case actionTypes.SET_DELETED_DATA_INELIGIBLE_CPT:
      return { ...state, deletedData: action.payload };
    default:
      return state;
  }
};

export default reducer;
